<template>
  <!-- https://buefy.org/documentation/field -->
  <b-field
    v-bind="$attrs"
    :label="!showLabel ? label : null"
    :type="type"
    class="form_field"
    :custom-class="customClass"
    :label-for="labelFor"
    :message="helpText"
  >
    <template #label v-if="showLabel">
      <div class="flex flex-between">
        <span>{{ label }}</span>
        <span
          :class="['show_label', {'disabled': !showValue}]"
          @click="toggleShowValue"
        >{{ showAdjective }} {{ showLabel }}</span>
      </div>
      <p v-if="isShown" class="show_value">{{ showValue }}</p>
    </template>

    <slot></slot>

    <form-validation-errors :validation-errors="validationErrors"></form-validation-errors>
  </b-field>
</template>

<script>
  import FormValidationErrors from "./FormValidationErrors";
  export default {
    name: "FormField",
    components: {FormValidationErrors},
    props: {
      validationErrors: {
        type: [String, Array, undefined],
      },
      label: {
        type: [String, undefined],
      },
      isDarkText: {
        type: [Boolean, undefined],
      },
      disabled: {
        type: [Boolean, undefined],
      },
      labelFor: {
        type: String
      },
      helpText: {
        type: String
      },
      showLabel: {
        type: String
      },
      showValue: {
        type: String
      },
      isLabelError: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isShown: false
      }
    },
    computed: {
      customClass() {
        if(this.isLabelError) {
          return 'form_field--label has-text-danger'
        }

        return 'form_field--label'
      },
      showAdjective() {
        if(this.showValue) {
          return this.isShown ? 'hide' : 'view';
        }

        return 'no';
      },
      errorMessages() {
        if (!this.validationErrors) {
          return [];
        }

        if (typeof (this.validationErrors) === 'string') {
          return [this.validationErrors];
        }

        return this.validationErrors;
      },
      type() {
        if (this.disabled) return 'is-light';
        if (this.errorMessages.length) return 'is-danger';

        return 'is-black'
      }
    },
    methods: {
      toggleShowValue() {
        if(this.showValue) {
          this.isShown = !this.isShown;
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";
// Due to how Buefy works these styles must be in global styles

.form_field {
  ::v-deep .field.has-addons {
    flex-wrap: wrap;
  }
}

.show_label {
  font-size: 12px;
  color: $secondary;
  cursor: pointer;

  &.disabled {
    color: $text-light;
    cursor: not-allowed;
  }
}

.show_value {
  margin: 6px 0 8px;
}
</style>
